(function() {
  function toggleMenu() {
    var n = document.getElementById('navLinks');
    var b = document.getElementById('hamburger');
    if (!n || !b) return;
    n.classList.toggle('open');
    b.classList.toggle('open');
    b.setAttribute('aria-label', n.classList.contains('open') ? 'Close menu' : 'Open menu');
    document.body.style.overflow = n.classList.contains('open') ? 'hidden' : '';
  }
  window.toggleMenu = toggleMenu;

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('#navLinks a').forEach(function(l) {
      l.addEventListener('click', function() {
        var n = document.getElementById('navLinks');
        var b = document.getElementById('hamburger');
        if (n) n.classList.remove('open');
        if (b) b.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('.reveal').forEach(function(el) { obs.observe(el); });
  });
})();
// FAQ accordion
document.querySelectorAll('.faq-q').forEach(function(btn){
  btn.addEventListener('click',function(){
    var expanded=btn.getAttribute('aria-expanded')==='true';
    btn.setAttribute('aria-expanded',String(!expanded));
    btn.nextElementSibling.hidden=expanded;
  });
});